import { message } from 'antd';
import { getVerifyCode, checkVerifyCode, updatePasswordPc, getPasswordConfig } from '../services/password';

export default {
  namespace: 'resetPassword',
  state: {
    resetVisible: false,
    initPwd: '',
    forceUpdatePwd: false,
    verifyPwdStrength: false,
    btnDisabled: false,
    btnTitle:''
  },
  effects: {
    * sendCode({ payload }, { call, put }) {
      const { account } = payload;
      const res = yield call(getVerifyCode, payload:{account:account});
      if (res && res.code === 200) {
        message.success(res.message);
        yield put({type:'updateBottonDisabled',payload:false});
      } else {
        message.warn(res.message);
      }
    },
    * savePassword({payload}, {call, put}) {
      const {account, verifyCode, confirmPassword, newPassword} = payload;
      const params = {
        account,
        verifyCode:verifyCode,
        newPassword: app.rsaString(newPassword),
        confirmPassword: app.rsaString(confirmPassword)
      };
      const response = yield call(updatePasswordPc, params);
      if (response && response.code === 200) {
        message.success(response.message);
        yield put({type: 'updateReset', payload: {resetVisible: false}});
      } else {
        message.warn(response.message);
      }
    },
    * getSysPasswordConfig({ payload }, { call, put }) {
      const res = yield call(getPasswordConfig);
      if (res && res.code === 200) {
        if (res.result && res.result.forceUpdatePwd) {
          yield put({ type: 'updateForceUpdatePwd',
            payload: { initPwd: res.result.initPwd,
              forceUpdatePwd: res.result.forceUpdatePwd } });
        }
        if (res.result && res.result.verifyPwdStrength) {
          yield put({ type: 'updateVerifyPwdStrength', payload: { verifyPwdStrength: res.result.verifyPwdStrength } });
        }
        let pswChangeWay = res.result.pswChangeWay
        if (res.result && pswChangeWay) {
          let btnTitle=''
          if(pswChangeWay.length == 2){
            btnTitle = "发送验证码到手机及邮箱"
          }else{
            if(pswChangeWay[0] == 'sms'){
              btnTitle = "发送验证码到手机"
            }
            if(pswChangeWay[0] == 'mail'){
              btnTitle = "发送验证码到邮箱"
            }
          }
          yield put({ type: 'updateBtnTitle', payload: { btnTitle: btnTitle } });
          yield put({ type: 'updateReset', payload: { resetVisible: true } });
        }else{
          message.warn("请联系系统管理员配置验证码发送方式")
        }
      } else {
        message.warn(res.result.message);
      }
    },
  },
  reducers: {
    updateReset(state, { payload }) {
      return { ...state, resetVisible: payload.resetVisible };
    },
    updateForceUpdatePwd(state, { payload }) {
      return { ...state,
        initPwd: payload.initPwd,
        forceUpdatePwd: payload.forceUpdatePwd };
    },
    updateVerifyPwdStrength(state, { payload }) {
      return { ...state,
        verifyPwdStrength: payload.verifyPwdStrength };
    },
    updateBtnTitle(state, { payload }) {
      return { ...state,
        btnTitle: payload.btnTitle };
    },
    updateBottonDisabled(state, { payload }) {
      return { ...state, btnDisabled: payload };
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/resetPasssword.js